import * as React from 'react'
import { NoticeProps, components } from 'react-select'
import { TSkillOption } from '../skill-select.types'

export const NoOptionsMessage = (props: NoticeProps<TSkillOption, true>) => (
  <components.NoOptionsMessage {...props} className="p-4 text-gray-600">
    {props.children}
  </components.NoOptionsMessage>
)
